import React, { useRef, forwardRef } from 'react';

const testWhite = x => {
  var white = new RegExp(/^\s$/);
  return white.test(x.charAt(0));
};

const wordWrap = (str, maxWidth) => {
  var newLineStr = '#';
  var done = false;
  var res = '';
  var newStr = '';
  do {
    let found = false;
    // Inserts new line at first whitespace of the line
    for (let i = maxWidth - 1; i >= 0; i--) {
      if (testWhite(str.charAt(i))) {
        res = res + [ str.slice(0, i), newLineStr ].join('');
        str = str.slice(i + 1);
        found = true;
        break;
      }
    }
    // Inserts new line at maxWidth position, the word is too long to wrap
    if (!found) {
      res += [ str.slice(0, maxWidth), newLineStr ].join('');
      str = str.slice(maxWidth);
    }

    if (str.length < maxWidth) done = true;
  } while (!done);

  newStr = res + str;
  return newStr.split('#');
};

const AntrianPendaftaran = ({ data, puskesmasProfile }) => {
  const paperWidth = 302.36220472;
  const paperHeight = 415.7480315;
  const canvasRef = useRef();
  const imageRef = useRef();

  const renderCanvas = (paramRef, paramImageRef, paramData) => {
    console.log(paramData);
    
    if (!paramRef.current || paramData === '') return '';

    const canvas = paramRef.current;
    const image = paramImageRef.current;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, paperWidth, paperHeight);

    const imageWidth = image.width * 0.1;
    const imageHeight = image.height * 0.1;

    ctx.drawImage(
      image,
      canvas.width / 2 - imageWidth / 2,
      20,
      imageWidth,
      imageHeight
    );

    ctx.font = '18px Arial';
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.fillText(puskesmasProfile.name, canvas.width / 2, 110);
    ctx.font = '14px Arial';

    const newStrAddresses = wordWrap(
      puskesmasProfile.address,
      40
    );

    let verticalMargin = 130;

    newStrAddresses.map(newStrAddress => {
      ctx.textAlign = 'center';
      ctx.fillText(newStrAddress, canvas.width / 2, verticalMargin);
      verticalMargin += 20;
      return '';
    });

    ctx.beginPath();
    ctx.moveTo(0, verticalMargin + 10);
    ctx.lineTo(340.15748031, verticalMargin + 10);
    ctx.lineWidth = 5;
    ctx.strokeStyle = '#000000';
    ctx.font = '20px Arial';
    ctx.stroke();

    ctx.font = '24px Arial';
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.fillText('Antrian Pendaftaran', canvas.width / 2, 230);
    ctx.font = '36px Arial';
    ctx.fillText(paramData.queue, canvas.width / 2, 280);
    ctx.font = '26px Arial';
    ctx.fillText(paramData.clinic_name, canvas.width / 2, 330);
    ctx.font = '12px Arial';
    ctx.fillText(paramData.created_at, canvas.width / 2, 380);
  };

  return (
    <>
      {renderCanvas(canvasRef, imageRef, data)}
      <img
        ref={ imageRef }
        className='d-none'
        src={process.env.REACT_APP_LOGO}
        alt='img'
      />
      <canvas ref={ canvasRef } width={ paperWidth } height={ paperHeight } />
    </>
  );
};

const AntrianPoli = ({ data, puskesmasProfile }) => {
  const paperWidth = 302.36220472;
  const paperHeight = 415.7480315;
  const canvasRef = useRef();
  const imageRef = useRef();

  const renderCanvas = (paramRef, paramImageRef, paramData) => {
    if (!paramRef.current || paramData === '') return '';
    const canvas = paramRef.current;
    const image = paramImageRef.current;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, paperWidth, paperHeight);

    const imageWidth = image.width * 0.1;
    const imageHeight = image.height * 0.1;

    ctx.drawImage(
      image,
      canvas.width / 2 - imageWidth / 2,
      20,
      imageWidth,
      imageHeight
    );

    ctx.font = '18px Arial';
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.fillText(puskesmasProfile.name, canvas.width / 2, 110);
    ctx.font = '14px Arial';

    const newStrAddresses = wordWrap(
      puskesmasProfile.address,
      40
    );

    let verticalMargin = 130;

    newStrAddresses.map(newStrAddress => {
      ctx.textAlign = 'center';
      ctx.fillText(newStrAddress, canvas.width / 2, verticalMargin);
      verticalMargin += 20;
      return '';
    });

    console.log(paramData);

    ctx.beginPath();
    ctx.moveTo(0, verticalMargin + 10);
    ctx.lineTo(340.15748031, verticalMargin + 10);
    ctx.lineWidth = 5;
    ctx.strokeStyle = '#000000';
    ctx.font = '20px Arial';
    ctx.stroke();

    ctx.font = '24px Arial';
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.fillText('Pasien Asuransi', canvas.width / 2, 230);
    ctx.font = '36px Arial';
    ctx.fillText(paramData.queue.queue, canvas.width / 2, 280);
    ctx.font = '12px Arial';
    ctx.fillText('POLIKLINIK', canvas.width / 2, 310);
    ctx.fillText(`NO. RM ${ paramData.family_folder }`, canvas.width / 2, 330);
    ctx.fillText(
      `${ paramData.name } ${ paramData.lastname || '' }`,
      canvas.width / 2,
      350
    );
    ctx.font = '12px Arial';
    ctx.fillText(paramData.queue.created_at, canvas.width / 2, 380);
  };

  return (
    <>
      {renderCanvas(canvasRef, imageRef, data)}
      <img
        ref={ imageRef }
        className='d-none'
        src='https://upload.wikimedia.org/wikipedia/commons/9/92/Lambang_Kabupaten_Sleman.png '
        alt='img'
      />
      <canvas ref={ canvasRef } width={ paperWidth } height={ paperHeight } />
    </>
  );
};

const AntrianPoliTracer = ({ data, puskesmasProfile }) => {
  const paperWidth = 302.36220472;
  const paperHeight = 200;
  const canvasRef = useRef();

  const renderCanvas = (paramRef, paramData) => {
    if (!paramRef.current || paramData === '') return '';
    const canvas = paramRef.current;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, paperWidth, paperHeight);

    ctx.font = '14px Arial';
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.fillText(
      `TRACER ${ paramData.clinicInfo.name.toUpperCase() } ${ paramData.queue.created_at }`,
      canvas.width / 2,
      30
    );
    ctx.font = '14px Arial';

    ctx.font = '16px Arial';
    ctx.textAlign = 'center';
    ctx.fillText(`NO. RM ${ paramData.family_folder }`, canvas.width / 2, 60);
    ctx.fillText(
      `NAMA : ${ paramData.name } ${ paramData.last_name || '' }`,
      canvas.width / 2,
      80
    );
    ctx.font = '30px Arial';
    ctx.fillText(paramData.queue.queue, canvas.width / 2, 120);

    ctx.beginPath();
    ctx.moveTo(0, 140);
    ctx.lineTo(340.15748031, 140);
    ctx.lineWidth = 5;
    ctx.strokeStyle = '#000000';
    ctx.font = '20px Arial';
    ctx.stroke();

    ctx.font = '14px Arial';
    ctx.fillText('Diserahkan ke Pendaftaran', canvas.width / 2, 170);
  };

  return (
    <>
      {renderCanvas(canvasRef, data)}
      <canvas ref={ canvasRef } width={ paperWidth } height={ paperHeight } />
    </>
  );
};

const AntrianPoliMR = ({ data, puskesmasProfile }) => {
  const paperWidth = 302.36220472;
  const paperHeight = 300;
  const canvasRef = useRef();

  const renderCanvas = (paramRef, paramData) => {
    if (!paramRef.current || paramData === '') return '';
    const canvas = paramRef.current;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, paperWidth, paperHeight);

    ctx.font = '14px Arial';
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.fillText(
      `${ paramData.clinicInfo.name.toUpperCase() } 09-01-2020 10:32:18`,
      canvas.width / 2,
      30
    );

    ctx.beginPath();
    ctx.moveTo(0, 40);
    ctx.lineTo(340.15748031, 40);
    ctx.lineWidth = 5;
    ctx.strokeStyle = '#000000';
    ctx.font = '20px Arial';
    ctx.stroke();

    ctx.font = '16px Arial';
    ctx.textAlign = 'center';
    ctx.fillText(`NO. RM ${ paramData.family_folder }`, canvas.width / 2, 60);
    ctx.font = '14px Arial';
    ctx.fillText(
      `NAMA : ${ paramData.name } ${ paramData.last_name || '' }`,
      canvas.width / 2,
      80
    );
    ctx.fillText(`ALAMAT : ${ paramData.address }`, canvas.width / 2, 100);
    ctx.fillText(
      `TANGGAL LAHIR : ${ paramData.birth_date }`,
      canvas.width / 2,
      120
    );
    ctx.fillText(
      `JAMKESMAS : ${ paramData.insurance_no }`,
      canvas.width / 2,
      140
    );

    ctx.font = '30px Arial';
    ctx.fillText(paramData.queue.queue, canvas.width / 2, 190);

    ctx.beginPath();
    ctx.moveTo(0, 210);
    ctx.lineTo(340.15748031, 210);
    ctx.lineWidth = 5;
    ctx.strokeStyle = '#000000';
    ctx.font = '20px Arial';
    ctx.stroke();

    ctx.font = '14px Arial';
    ctx.fillText('Diserahkan ke Pendaftaran', canvas.width / 2, 230);
  };

  return (
    <>
      {renderCanvas(canvasRef, data)}
      <canvas ref={ canvasRef } width={ paperWidth } height={ paperHeight } />
    </>
  );
};

const renderAntrian = (type, data, puskesmasProfile) => {
  switch (type) {
  case 'pendaftaran':
    return <AntrianPendaftaran data={ data } puskesmasProfile={ puskesmasProfile } />;
    break;
  case 'poli':
    return <AntrianPoli data={ data } puskesmasProfile={ puskesmasProfile } />;
    break;
  case 'poli_tracer':
    return <AntrianPoliTracer data={ data } puskesmasProfile={ puskesmasProfile } />;
    break;
  case 'poli_mr':
    return <AntrianPoliMR data={ data } puskesmasProfile={ puskesmasProfile } />;
    break;
  default:
    break;
  }
};

const Print = forwardRef((props, ref) => (
  <div ref={ ref }>{renderAntrian(props.type, props.data, props.puskesmasProfile)}</div>
));

export default Print;
